/* eslint-disable */
import axios from "axios";

// ============================================================
// ENVIRONMENT CONFIGURATION
// ============================================================
// To switch environments, change the ACTIVE_ENV value below:
// Options: 'localhost', 'demo', 'uat', 'homabay', 'homabay_uat', 'production'
//const ACTIVE_ENV = 'localhost';
//const ACTIVE_ENV = 'homabay_uat';
const ACTIVE_ENV = 'homabay';

const ENV_URLS = {
  localhost: process.env.VUE_APP_BASE_URL_HRMS_LOCALHOST || "http://localhost/homabay-hr/authentication",
  demo: process.env.VUE_APP_BASE_URL_HRMS_DEMO || "https://api.paysol.co.ke/hrms/authentication/",
  uat: process.env.VUE_APP_BASE_URL_HRMS_UAT || "https://staffsync.cspl-uat.site/authentication/",
  production: process.env.VUE_APP_BASE_URL_HRMS || "https://rcmsuat.craftsilicon.com/hrmis-api/authentication/",
  homabay: process.env.VUE_APP_BASE_URL_HRMS_HOMABAY || "https://api.craftcollect.africa/hrmis/",
  homabay_uat: process.env.VUE_APP_BASE_URL_HRMS_HOMABAY_UAT || "https://rcmsuat.craftsilicon.com/homabay_hrmis/"
};

// Get the selected environment URL
const getBaseUrl = () => {
  const selectedUrl = ENV_URLS[ACTIVE_ENV] || ENV_URLS.localhost;
  return selectedUrl.replace(/\/+$/, ""); // Remove trailing slashes
};

const hrmsBase = getBaseUrl();

let localDevBase = hrmsBase;
try {
  localDevBase = new URL(hrmsBase).pathname.replace(/\/+$/, "");
} catch (e) {
  // hrmsBase may not be a valid absolute URL in some edge cases
}

// Use full URL for production, pathname for development
export const base = process.env.NODE_ENV === "development" && ACTIVE_ENV === 'localhost' 
  ? localDevBase 
  : hrmsBase;

console.log(`🌍 Active Environment: ${ACTIVE_ENV}`);
console.log(`🔗 Base URL: ${base}`);
//export const base = process.env.VUE_APP_BASE_URL_HRMS_HOMABAY_UAT
//export const base = process.env.VUE_APP_BASE_URL_HRMS_HOMABAY

export const county_logo = base + "/logos/logo.png";
export const login_bg = base + "/logos/bg-auth-overlay.png";
export const paysol = base + "/paysol/index.php";
export const authUrl = base + "/index.php";

export const uploads = base;



// Toast notification utility
export const toast = {
    success(message) {
        this._showToast(message, 'success');
    },
    error(message) {
        this._showToast(message, 'error');
    },
    warning(message) {
        this._showToast(message, 'warning');
    },
    info(message) {
        this._showToast(message, 'info');
    },
    _showToast(message, type) {
        // Create toast element
        const toast = document.createElement('div');
        toast.className = `toast-notification toast-${type}`;
        toast.style.cssText = `
      position: fixed;
      min-width: 250px;
      margin-bottom: 10px;
      padding: 15px;
      border-radius: 4px;
      box-shadow: 0 2px 10px rgba(0,0,0,0.2);
      transform: translateY(30px);
      opacity: 0;
      transition: all 0.3s ease;
      z-index: 9999;
      color: white;
    `;

        // Apply color based on type
        switch(type) {
            case 'success':
                toast.style.backgroundColor = '#4caf50';
                break;
            case 'error':
                toast.style.backgroundColor = '#f44336';
                break;
            case 'warning':
                toast.style.backgroundColor = '#ff9800';
                break;
            case 'info':
                toast.style.backgroundColor = '#2196f3';
                break;
        }

        toast.innerHTML = `
      <div style="display: flex; align-items: center;">
        <div style="flex-grow: 1;">${message}</div>
      </div>
    `;

        // Add to DOM
        const container = document.getElementById('toast-container') || this._createContainer();
        container.appendChild(toast);

        // Trigger animation
        setTimeout(() => {
            toast.style.transform = 'translateY(0)';
            toast.style.opacity = '1';
        }, 10);

        // Auto-remove after 3 seconds
        setTimeout(() => {
            toast.style.transform = 'translateY(30px)';
            toast.style.opacity = '0';
            setTimeout(() => {
                if (container.contains(toast)) {
                    container.removeChild(toast);
                }
                // Remove container if empty
                if (container.children.length === 0 && document.body.contains(container)) {
                    document.body.removeChild(container);
                }
            }, 300);
        }, 3000);
    },
    _createContainer() {
        const container = document.createElement('div');
        container.id = 'toast-container';
        container.style.cssText = `
      position: fixed;
      bottom: 20px;
      right: 20px;
      z-index: 9999;
    `;
        document.body.appendChild(container);
        return container;
    }
};

export const execute = (params, url) => {
    const tokenStr = sessionStorage.getItem("tokenSession");
    return axios.post(url,params,{headers: {"Authorization": `Bearer ${tokenStr}`}})
}

export const executeJson = (params, url) => {
    const tokenStr = sessionStorage.getItem("tokenSession");
    return axios.post(url, params, {
        headers: {
            "Authorization": `Bearer ${tokenStr}`,
            "Content-Type": "application/json"
        }
    });
}

export const executeDownload = (params, url) => {
    const tokenStr = sessionStorage.getItem("tokenSession");
    return axios.post(url,params,{headers: {"Authorization": `Bearer ${tokenStr}`}, responseType: 'blob'})
}

export const execute2 = (params, url) => {
    return axios.post(url,params)
}

/**
 * Check if current user has a permission (RBAC).
 * Uses rbac_permissions from getPermissionsAndMenus when available; else falls back to selectedRoles (legacy).
 * No category or role-name superuser bypass — ADMIN/SUPERADMIN must have permissions via roles like everyone else.
 * accessRole can be a string (single permission) or array of strings (user needs any one).
 */
export const getRight = (accessRole) => {
    if (!accessRole) return true;
    const codes = Array.isArray(accessRole) ? accessRole : [accessRole];
    const norm = (s) => String(s || '').trim().toUpperCase();
    let rbacLoaded = false;
    let rbacPerms = [];
    try {
        rbacLoaded = sessionStorage.getItem("rbac_menus_loaded") === "1";
        const rbacStr = sessionStorage.getItem("rbac_permissions");
        if (rbacStr) {
            const perms = JSON.parse(rbacStr);
            if (Array.isArray(perms)) rbacPerms = perms;
        }
    } catch (_) {}

    for (const access of codes) {
        const code = norm(access);
        if (!code) continue;

        if (rbacPerms.some((p) => norm(p) === code)) return true;

        // When RBAC has already loaded in this session, do NOT fallback to legacy selectedRoles.
        if (rbacLoaded) continue;

        const selectedRolesString = sessionStorage.getItem("selectedRoles");
        if (selectedRolesString) {
            try {
                const selectedRoles = JSON.parse(selectedRolesString);
                if (Array.isArray(selectedRoles)) {
                    for (const role of selectedRoles) {
                        const name = role.role_name || role.roleName || '';
                        if (norm(name) === code) return true;
                    }
                }
            } catch (e) {
                console.error("Error parsing selectedRoles:", e);
            }
        }
    }
    return false;
};

/** Fetch permissions and menus from backend (RBAC). Stores rbac_permissions and rbac_menus in sessionStorage. */
let rbacFetchInFlight = null;
export const fetchPermissionsAndMenus = (authUrl, execute) => {
    if (rbacFetchInFlight) return rbacFetchInFlight;
    const data = new FormData();
    data.append("function", "getPermissionsAndMenus");
    rbacFetchInFlight = execute(data, authUrl).then((res) => {
        if (res.data && res.data.success && res.data.data) {
            const d = res.data.data;
            sessionStorage.setItem("rbac_permissions", JSON.stringify(d.permissions || []));
            sessionStorage.setItem("rbac_menus", JSON.stringify(d.menus || []));
            sessionStorage.setItem("rbac_context", JSON.stringify(d.context || {}));
            sessionStorage.setItem("rbac_menus_loaded", "1");
        }
        return res;
    }).finally(() => {
        rbacFetchInFlight = null;
    });
    return rbacFetchInFlight;
};

/**
 * Format Kenyan mobile number to 254XXXXXXXXX.
 * Converts 0726642205, +254726642205, 254726642205 to 254726642205.
 * Handles numbers and scientific notation (e.g. 2.54705E+11) so they display as full digits.
 * @param {string|number} value - Raw phone (0726642205, +254726642205, 254726642205, or number)
 * @returns {string} - 254726642205 format, or original if not a Kenyan mobile
 */
export const formatMobileKe = (value) => {
    if (value == null || value === '') return value;
    // Avoid scientific notation: coerce number or "2.54705E+11" to full digit string
    let s;
    if (typeof value === 'number' || (typeof value === 'string' && /e[+-]?\d+/i.test(value))) {
        const n = Number(value);
        if (!Number.isNaN(n)) s = n >= 1e9 ? String(Math.floor(n)) : String(value).trim();
        else s = String(value).trim();
    } else {
        s = String(value).trim();
    }
    const digits = s.replace(/\D/g, '');
    if (digits.length < 9) return s;
    if (digits.startsWith('0') && digits.length >= 10) return '254' + digits.substring(1);
    if (digits.startsWith('254')) return digits.length > 12 ? digits.substring(0, 12) : digits;
    if (digits.length >= 9) return '254' + digits.slice(-9);
    return s;
};